import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SendMultiPaymentReminderQuery, SendMultiPaymentReminderQueryHandlerBase, SendSinglePaymentReminderQuery, SendSinglePaymentReminderQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SendSinglePaymentReminderQuery)
@Wrapper(SendSinglePaymentReminderQueryHandlerBase)
export class SendPaymentReminderQueryHandler {
    public constructor(
        http: Http
    ) { }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SendMultiPaymentReminderQuery)
@Wrapper(SendMultiPaymentReminderQueryHandlerBase)
export class SendMultiPaymentReminderQueryHandler {
    public constructor(
        http: Http
    ) { }
}
